// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b41a3084","770":"1fde0b18"}[chunkId] + ".chunk.js";
};